// extracted by mini-css-extract-plugin
module.exports = {"navigator":"navigatorBar_navigator__3Xyvp"};